<template>
  <v-card class="card-border">
    <v-card-text>
      <v-form>
        <v-row dense align="center">
          <v-col cols="12" sm="12" md="4">
            <SelectEmpresa :multiple="true" @onChanged="empresas = $event" />
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <SelectFilterBy @onChanged="filterBy = $event; changeFilterBy($event)" />
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <SelectTemperatura
              @onChanged="temperatura = $event"
              :disabled="disableSelectTemperatura"
              :validate="validateSelectTemperatura"
            />
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <DateMenu
              label="Data Inicio"
              @onChanged="dateStart = $event"
              :disabled="disableSelectDate"
            />
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <DateMenu label="Data Fim" @onChanged="dateEnd = $event" :disabled="disableSelectDate" />
          </v-col>
          <v-col cols="12" sm="12" md="2">
            <v-btn outlined color="blue darken-2" rounded dark depressed small @click="buscar()">
              <v-icon left>mdi-magnify</v-icon>Buscar
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { Administrativo } from "@/services/lead";

export default {
  name: "Filtro",

  components: {
    SelectFilterBy: () => import("../../components/SelectFilterBy"),
    SelectTemperatura: () => import("@/components/select/SelectTemperatura"),
    DateMenu: () => import("@/components/datepicker/DateMenu"),
    SelectEmpresa: () => import("@/components/select/SelectEmpresa")
  },

  data() {
    return {
      filterBy: "",
      temperatura: "",
      disableSelectTemperatura: false,
      validateSelectTemperatura: true,
      disableSelectDate: false,
      dateStart: new Date(),
      dateEnd: new Date(),
      empresas: [],
      serviceLeadsAdministrativo: new Administrativo()
    };
  },

  methods: {
    ...mapActions("leads", ["setLeads"]),

    async buscar() {
      try {
        let response = [];
        if (this.filterBy == "Temperatura") {
          response = await this.serviceLeadsAdministrativo.getLeadsByTemperatura(
            this.empresas,
            this.temperatura
          );
        } else if (this.filterBy == "Data Criação") {
          response = await this.serviceLeadsAdministrativo.getLeadsByDataCriacao(
            this.empresas,
            this.dateStart,
            this.dateEnd
          );
        } else if (this.filterBy == "Data Proximo Contato") {
          response = await this.serviceLeadsAdministrativo.getLeadsByDataProxContato(
            this.empresas,
            this.dateStart,
            this.dateEnd
          );
        }
        this.setLeads(response);
        return Promise.resolve();
      } catch (error) {
        this.$toast.error("Erro ao carregar Dados");
        return Promise.reject(error);
      }
    },

    changeFilterBy() {
      if (this.filterBy == "Temperatura") {
        this.disableSelectTemperatura = false;
        this.validateSelectTemperatura = true;
        this.disableSelectDate = true;
      } else {
        this.disableSelectTemperatura = true;
        this.validateSelectTemperatura = false;
        this.disableSelectDate = false;
      }
    }
  }
};
</script>
